namespace Cfnc {
    "use strict";

    interface ICfncPassword extends angular.IDirective {
        templateUrl: string;
    }

    interface ICfncPasswordScope extends angular.IScope {
        password: any;
        confirmPassword: any;
        formGroupCssClass: string[];
        labelCssClass: string[];
        inputCssClass: string[];
        passwordLabel: string;
        confirmPasswordLabel: string;
        inlineForm: boolean;

        required: boolean;
        maxlength: number;
        minlength: number;

        
    }

    interface ICfncPasswordAttributes extends angular.IAttributes {
        formGroupCss: string;
        labelCss: string;
        inputCss: string;
        passwordLabel: string;
        confirmPasswordLabel: string;
        inlineForm: string;
    }

    

    CfncPassword.$inject = [];

    function CfncPassword(): ICfncPassword {

        // Usage:
        //     <cfnc-password
        //        form-group-css (Type: string, default: null): A list of classes separated by a space
        //        label-css (Type: string, default: null): A list of classes separated by a space
        //        input-css (Type: string, default: null): A list of classes separated by a space
        //        password-label (Type: string, default: "Password"): The text to use for the password field label
        //        confirm-password-label (Type: string, default: "Confirm Password"): The text to use for the confirm password field label
        //        inline-form (Type: boolean, default: true): Setting this to true will use the inline-form template
        //        ></cfnc-password>

        return {
            restrict: "EA",
            link: link,
            templateUrl: "/app/directives/cfncPassword/cfncPassword.html",
            controller: cfncPasswordCtrl,
            controllerAs: "vm",
            bindToController: true,
            scope: {
                password: "=",
                confirmPassword: "="
            }

        }

        function link(scope: ICfncPasswordScope, element: angular.IAugmentedJQuery, attrs: ICfncPasswordAttributes) {
            scope.formGroupCssClass = attrs.formGroupCss ? attrs.formGroupCss.split(" ") : [];
            scope.labelCssClass = attrs.labelCss ? attrs.labelCss.split(" ") : [];
            scope.inputCssClass = attrs.inputCss ? attrs.inputCss.split(" ") : [];
            scope.passwordLabel = attrs.passwordLabel || "Password";
            scope.confirmPasswordLabel = attrs.confirmPasswordLabel || "Confirm Password";
            scope.inlineForm = (attrs.inlineForm && attrs.inlineForm == "false") ? false : true;
            
            //validation values
            scope.required = true;
            scope.minlength = 8;
            scope.maxlength = 200;
        }

        function cfncPasswordCtrl() {}
        
        
    }

    angular.module("app").directive("cfncPassword", CfncPassword);
}